import React from 'react';
import DataTable from '@/util/DataTable';
import css from '@/css/module/new-world.css';
import { DrilldownTable } from './DrilldownTable';

export const DrilldownSubTable: React.FC<{
  dataTable: Maybe<DataTable>;
  isLoading: boolean;
  errorMessage?: Maybe<string>;
}> = ({ dataTable, isLoading, errorMessage }) => (
  <tr>
    <td className="no-border" />
    <td className="expanded-cell">
      <DrilldownTable
        dataTable={dataTable}
        isLoading={isLoading}
        errorMessage={errorMessage}
        className={`expanded-cell ${css.expandedCell}`}
      />
    </td>
  </tr>
);
